import { baseApi } from 'api/base';
import {
  FindFnParams,
  PaginationResponse,
  DefaultFindFnParams,
} from 'components/registry/types/api';
import { fileApi } from 'api/file';
import { GmpRegistryParams, GmpDto } from './params';

const MAIN_URL = '/gmp-compliance-conclusions';

const findRegistry = async (
  params: FindFnParams<GmpRegistryParams>
): Promise<PaginationResponse<GmpDto>> => {
  const res = await baseApi.post(`${MAIN_URL}/find`, params);
  return res.data;
};

const deleteCard = async (id: string) => {
  await baseApi.delete(`${MAIN_URL}/${id}`);
};

const getExcel = async (data: DefaultFindFnParams) =>
  baseApi.post(`${MAIN_URL}/excel`, data, { responseType: 'blob' }).then(fileApi.downloadFile);

export const registryApi = {
  findRegistry,
  getExcel,
  deleteCard,
};
